import Vue from 'vue'
import store from '@/store'
import VueRouter from 'vue-router'
import publicHome from '../views/_Public.vue'
import privateHome from '../views/_Private.vue'
import invoices from '@/router/modules/invoices' 
import verifactu from '@/router/modules/verifactu' 
import masters from '@/router/modules/masters' 
import companies from '@/router/modules/companies'
import certificates from '@/router/modules/certificates'
import configurations from '@/router/modules/configurations'
import notices from '@/router/modules/notices'
import trash from '@/router/modules/trash'
import dashboard from '@/router/modules/dashboard'
import { RUTAS_CAMBIOS_FORMULARIOS } from '@/config/ruta-cambios-formularios'

import { getTransitionAllowed, setTransitionAllowed } from '@/services/functions/modeAllowedTransitionHelper'
import { preserve, discard } from '@/services/functions/preserve&discard'

import { i18n } from '@/i18n'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: publicHome,
    children: [
      {
        path: 'login',
        name: 'login',
        meta: { type: 'public', title: i18n.t('app.title_login') },
        component: () => import('@/views/Login.vue')
      },
      {
        path: '',
        name: 'signin',
        redirect: { name: 'login' }
      },
      {
        path: 'reset-password/:token',
        name: 'reset-password',
        meta: { type: 'public', title: i18n.t('app.title_resetpassowrd') },
        component: () => import('@/views/ResetPassword.vue')
      },
      {
        path: 'redirect',
        name: 'redirect',
        meta: { type: 'public', title: i18n.t('app.title_redirect') },
        component: () => import('@/views/RedirectionPage.vue')
      },
      {
        path: 'redirect/saml2',
        name: 'redirect/saml2',
        meta: { type: 'public', title: i18n.t('app.title_redirect') },
        component: () => import('@/views/RedirectSaml2.vue')
      },
      {
        path: 'redirect/error',
        name: 'redirect/error',
        meta: { type: 'public', title: i18n.t('app.title_error') },
        component: () => import('@/views/RedirectionError.vue')
      },
    ]
  },
  
  {
    path: '/'+process.env.VUE_APP_ROUTE_BASE,
    component: privateHome,
    children: [
      ...invoices,
      ...verifactu,
      ...masters,
      ...companies,
      ...certificates,
      ...configurations,
      ...trash,
      ...dashboard,
      ...notices,
      {
        path: 'missingmodule',
        name: 'missingmodule',
        meta: { type: 'private' },
        component: () => import('@/views/MissingModuleError.vue')
      },
      {
        path: 'redirect',
        name: 'redirectto',
        meta: { type: 'private' },
        component: () => import('@/views/RedirectionUrl.vue')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router

const handleModeTransition = function (to, from) {
  const modes = store.getters['config/ALLOWED_MODES']
  const currentModes = store.getters['app/currentModes'] || []
  for (const modeId of currentModes) {
    const mode = modes[modeId]
    if (mode) {
      const isValidRoute = mode.routes.concat('redirectto').includes(to.name)
      const isTransitionAllowed = !!getTransitionAllowed(modeId)
      const allowedByParam = to.params[mode.transitionAllowedParam] === true
      if ((isTransitionAllowed || allowedByParam) && isValidRoute) {
        if (to.name !== 'redirectto') {
          setTransitionAllowed(modeId, false)
        }
      } else {
        store.commit('app/exitMode', modeId)
      }
    }
  }
}
router.beforeEach(async (to, from, next) => {
  store.commit('app/setActualRoute', preserve(['name', 'path', 'params', 'query', 'meta'], to))
  store.commit('app/setfromRoute', { name: from.name, params: from.params, query: from.query })
  if (!from.name) {
    store.commit('app/resetheaderBreadCrumb')
  }

  let type = 'private'
  if (to.meta && to.meta.type) {
    type = to.meta.type
  }
  store.commit('app/setActualRoutePublic', (type === 'public'))

  if (to.path === '/reset-password') {
    return next({ name: 'reset-password' })
  }

  const loggedIn = store.getters['auth/loggedIn']
  if (type === 'private') {
    if (loggedIn) {
      if (store.getters['app/formChanges'] && RUTAS_CAMBIOS_FORMULARIOS.includes(from.name)) {
        const route = {
          path: to.path,
          params: to.params,
          query: to.query,
        }
        // Guardamos ruta para el diálogo y lo activamos
        store.commit('app/setLastRouteComplete', route)
        store.commit('app/setShowModalConfirmChanges', true)
        // Cancelamos ruta
        return
      }
      if (to.meta.modules?.length && to.meta.modules.some(x => x.length)) {
        const reqmodules = to.meta.modules.filter(x => x.length).map(x => x.map(y => Number.parseInt(y)))
        const modules = store.getters['auth/modules'].map(x => x.idModulo)
        if (!reqmodules.every(x => x.some(y => modules.includes(y)))) {
          store.commit('navigation/setTempNavigationData', { modules: reqmodules, route: discard(['matched'], to) })
          return next({ name: 'missingmodule' })
        } else if (to.name === 'missingmodule') {
          store.commit('navigation/clearTempNavigationData')
        }
      }

      // Hotfix refresh invoice types TMP
      if ((to.name === null || to.name === undefined) && to.path.includes('/'+process.env.VUE_APP_ROUTE_BASE+'/invoicesissued')) {
        return next({ name: 'invoicesissued' })
      }
      if ((to.name === null || to.name === undefined) && to.path.includes('/'+process.env.VUE_APP_ROUTE_BASE+'/invoicesreceived')) {
        return next({ name: 'invoicesreceived' })
      }
      if ((to.name === null || to.name === undefined) && to.path.includes('/'+process.env.VUE_APP_ROUTE_BASE+'/verifactu')) {
        // const pathStatus = parseInt(to.path.split('/').filter(x => x !== '').at(-1))
        // if (pathStatus !== 99999 && !isNaN(pathStatus)) {
        //   await store.dispatch('app/getEstadosFacturas')
        //   const invoicesVerifactu = store.getters['app/tiposAccionesFacturasGroups']

        //   if (invoicesVerifactu.RegistrosVerifactu.some(group => group.Estados.some(status => status.idEstado === pathStatus))) {
        //     const path = `/verifactu/${pathStatus}`
        //     const newRoute = {
        //       path: '/'+process.env.VUE_APP_ROUTE_BASE + path,
        //       name: path,
        //       components: { default: import('@/views/invoices/InvoicesIssued.vue') },
        //       params: { id: pathStatus },
        //       meta: { registerNavFromMenu: true, status: pathStatus }
        //     }
        //     router.addRoute('verifactu', newRoute)
        //     return next({ name: path })
        //   }
        // } 
        return next({ name: 'verifactu' })
      }
      if (!to.matched.length) {
        return next({ name: 'dashboard' })
      }
      handleModeTransition(to, from)
      return next()
    }
    const returnurl = to.name !== process.env.VUE_APP_REDIRECT_LOGGED_IN ? btoa(to.fullPath) : null
    const route = {
      name: process.env.VUE_APP_REDIRECT_FAILED_AUTHENTICATION, 
      params: null,
      query: null
    }
    if (returnurl) route.query = { returnurl }
    return next(route)
  }

  if (type === 'public') {
    if (loggedIn) {
      return next({ name: process.env.VUE_APP_REDIRECT_LOGGED_IN })
    }
  }

  return next()
})

router.afterEach((to, from) => {
  document.title = to.meta.title 
    ? to.meta.title + ' - InvoiZE' 
    : process.env.VUE_APP_TITLE
})
